module.exports = __webpack_public_path__ + "media/images/countryrect/bq-0ace7f85e39e84081f7ab0530d936129.svg";